import { Controller } from 'stimulus';

// Per-card expand / minimize for the new cards tasks index. The controller is
// on a card root (.tlv-row or .jlv-card); a toggle button (the compact chevron
// or the expanded card's minimize button) carries data-card-url and the target
// data-density. On click we fetch that single task rendered at the target
// density and replace this element in place. State is ephemeral (resets on the
// next full load); the global Compact/Expanded toggle remains the default.
export default class extends Controller {
  toggle(event) {
    event.preventDefault();
    const btn = event.currentTarget;
    const url = btn.dataset.cardUrl;
    const density = btn.dataset.density;
    if (!url || this.loading) return;

    this.loading = true;
    btn.disabled = true;

    const sep = url.includes('?') ? '&' : '?';
    fetch(`${url}${sep}density=${encodeURIComponent(density)}`, {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    })
      .then((r) => (r.ok ? r.text() : Promise.reject(new Error(`HTTP ${r.status}`))))
      .then((html) => {
        const root = this.element;
        const parent = root.parentElement;
        root.insertAdjacentHTML('afterend', html.trim());
        root.remove();
        // Let the sortable on the list re-scan so the swapped-in card/row is
        // immediately draggable (same hook infinite scroll uses).
        if (parent) parent.dispatchEvent(new CustomEvent('sortable:rescan', { bubbles: true }));
      })
      .catch((err) => {
        console.error('Card expand/minimize failed:', err);
        this.loading = false;
        btn.disabled = false;
      });
  }
}
